import React from 'react';
import { RouteObject } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';

const lazyLoadPages: () => Promise<typeof import('./DevicePages')> = () =>
  import(/* webpackPrefetch: true */ './DevicePages');

const DeviceRequestsPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.DeviceRequestsPage,
  })),
);

const DeviceLiveSessionPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.DeviceLiveSessionPage,
  })),
);

const DeviceRequestGroupDetailsPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.DeviceRequestGroupDetailsPage,
  })),
);

const DeviceObservationRedirectPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.DeviceObservationRedirectPage,
  })),
);

const DeviceObservationDetailsPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.DeviceObservationDetailsPage,
  })),
);

const DeviceSessionDetailsPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.DeviceSessionDetailsPage,
  })),
);

export const DeviceRoutes: RouteObject[] = [
  // Patient Devices
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_DEVICES, true),
    element: <DeviceRequestsPage />,
  },
  // Patient Device Live Session
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_DEVICE_LIVE_SESSION, true),
    element: <DeviceLiveSessionPage />,
  },
  // Patient Device Request Group Details
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_DEVICE_REQUEST_GROUP_DETAILS, true),
    element: <DeviceRequestGroupDetailsPage />,
  },
  // Patient Device Observation Redirect
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_DEVICE_OBSERVATION_REDIRECT, true),
    element: <DeviceObservationRedirectPage />,
  },
  // Patient Device Observation Details
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_DEVICE_OBSERVATION_DETAILS, true),
    element: <DeviceObservationDetailsPage />,
  },
  // Patient Device Session Details
  {
    path: PathUtil.toRelativePath(CspPath.PATIENT_NAV, CspPath.PATIENT_DEVICE_SESSION_DETAILS, true),
    element: <DeviceSessionDetailsPage />,
  },
];
